import { Main } from 'src/components/Layout';
import { usePageMeta } from 'src/hooks';
import { AddApplicationContainer } from 'src/containers/Application/Add';

const ApplicationNewPage = () => {
  usePageMeta('Create app');

  const breadcrumbItems = [{ label: 'Applications', to: '/applications' }, { label: 'Create app' }];

  return (
    <Main title="Add an application" breadcrumbItems={breadcrumbItems}>
      <div className="container mx-auto space-y-1 mb-6">
        <h1 className="text-base font-semibold">Create an application</h1>
        <p className="text-sm text-muted-foreground">
          Add software you build or rely on so Codekeeper can protect it. Choose one to get started.
        </p>
      </div>
      <div className="max-w-240 mx-auto space-y-6">
        <AddApplicationContainer />
      </div>
    </Main>
  );
};

export default ApplicationNewPage;
